export type OrionInboundContactSyncSettings = {
  autoSync: boolean
}

export type OrionInboundSyncSettings = {
  contact: OrionInboundContactSyncSettings
}

export type OrionSettingsFormValues = {
  inbound: OrionInboundSyncSettings
}

export const orionSettingsDefaultValues: OrionSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
